const COOKIE_REVOKE_SELECTOR = '.dp-cookie-policy-button.cc-revoke'
const DARK_FOOTER_CLASS = 'is-over-dark-footer'
const VISIBLE_ON_FOOTER_CLASS = 'is-visible-on-footer'
const DARK_LUMINANCE_THRESHOLD = 80
const OPAQUE_ALPHA_THRESHOLD = 0.5

const parseRgb = (color: string): { r: number; g: number; b: number; a: number } | null => {
  const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?/i)
  if (!match) {
    return null
  }

  return {
    r: Number(match[1]),
    g: Number(match[2]),
    b: Number(match[3]),
    a: match[4] !== undefined ? Number(match[4]) : 1,
  }
}

const isDarkBackground = (color: string): boolean => {
  const rgb = parseRgb(color)
  if (!rgb || rgb.a < OPAQUE_ALPHA_THRESHOLD) {
    return false
  }

  const luminance = 0.2126 * rgb.r + 0.7152 * rgb.g + 0.0722 * rgb.b
  return luminance < DARK_LUMINANCE_THRESHOLD
}

const isFooterInViewport = (footer: Element): boolean => {
  const footerRect = footer.getBoundingClientRect()

  return footerRect.top < window.innerHeight && footerRect.bottom > 0
}

const updateCookieRevokeContrast = (): void => {
  const button = document.querySelector(COOKIE_REVOKE_SELECTOR)
  const footer = document.querySelector('footer')

  if (!(button instanceof HTMLElement) || !(footer instanceof HTMLElement)) {
    return
  }

  const isVisible = isFooterInViewport(footer)
  button.classList.toggle(VISIBLE_ON_FOOTER_CLASS, isVisible)

  if (!isVisible) {
    button.classList.remove(DARK_FOOTER_CLASS)
    return
  }

  const footerBackground = window.getComputedStyle(footer).backgroundColor
  button.classList.toggle(DARK_FOOTER_CLASS, isDarkBackground(footerBackground))
}

export const initCookieRevokeContrast = (): (() => void) => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return () => undefined
  }

  let frameId = 0

  const scheduleUpdate = (): void => {
    if (frameId) {
      return
    }

    frameId = window.requestAnimationFrame(() => {
      frameId = 0
      updateCookieRevokeContrast()
    })
  }

  scheduleUpdate()

  window.addEventListener('scroll', scheduleUpdate, { passive: true })
  window.addEventListener('resize', scheduleUpdate)

  const portal = document.getElementById('byRemovePortal') || document.body
  const observer = new MutationObserver(scheduleUpdate)
  observer.observe(portal, { childList: true, subtree: true })

  return () => {
    if (frameId) {
      window.cancelAnimationFrame(frameId)
    }
    window.removeEventListener('scroll', scheduleUpdate)
    window.removeEventListener('resize', scheduleUpdate)
    observer.disconnect()
  }
}
